import DraftsTable from "components/Drafts/DraftsTable";
import MainLayout from "layout/MainLayout";

export default function Drafts(){
    return (
        <MainLayout>
            <DraftsTable/>
        </MainLayout>
    )
}